"use strict";
// Copyright (c) 2026 The Bitcoin developers
// Distributed under the MIT software license, see the accompanying
// file COPYING or http://www.opensource.org/licenses/mit-license.php.
Object.defineProperty(exports, "__esModule", { value: true });
exports.CURVE_ORDER = void 0;
exports.modCurveOrder = modCurveOrder;
exports.scalarToBytes = scalarToBytes;
exports.randomScalarBytes = randomScalarBytes;
const array_js_1 = require("./io/array.js");
/** secp256k1 group order n. */
exports.CURVE_ORDER = 0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141n;
/** Reduce `n` into [0, CURVE_ORDER). */
function modCurveOrder(n) {
    const r = n % exports.CURVE_ORDER;
    return r < 0n ? r + exports.CURVE_ORDER : r;
}
/** Big-endian 32-byte encoding of a scalar reduced into [0, n). */
function scalarToBytes(n) {
    let x = modCurveOrder(n);
    const out = new Uint8Array(32);
    for (let i = 31; i >= 0; i--) {
        out[i] = Number(x & 0xffn);
        x >>= 8n;
    }
    return out;
}
/**
 * Cryptographically random 32-byte scalar in [1, n).
 * Rejection sampling — no modular reduction of the RNG output (avoids bias).
 */
function randomScalarBytes() {
    const buf = new Uint8Array(32);
    for (;;) {
        crypto.getRandomValues(buf);
        const n = (0, array_js_1.bytesToScalar)(buf);
        if (n > 0n && n < exports.CURVE_ORDER) {
            return buf;
        }
    }
}
//# sourceMappingURL=eccScalar.js.map